import { render, staticRenderFns } from "./TarificationsEdit.vue?vue&type=template&id=44e45d20&"
import script from "./TarificationsEdit.vue?vue&type=script&lang=js&"
export * from "./TarificationsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports